import { AssessmentStatusAttemptEnum } from '@app/core/models';
import { AttemptStudentData } from '../store/modal-audit.state';

const STATUS_LABEL = {
  [999]: {
    text: 'gestor-avaliacoes.status.nao-iniciado',
    class: 'bg-gray-300',
  },
  [AssessmentStatusAttemptEnum.InProgress]: {
    text: 'gestor-avaliacoes.status.em-andamento',
    class: 'bg-base-status-info',
  },
  [AssessmentStatusAttemptEnum.Wait]: {
    text: 'gestor-avaliacoes.status.aguardando-correcao',
    class: 'bg-base-status-warning',
  },
  [AssessmentStatusAttemptEnum.Finish]: {
    text: 'gda.minhas.encerrada',
    class: 'bg-base-mantis-500',
  },
  [AssessmentStatusAttemptEnum.WaitDateResult]: {
    text: 'gda.minhas.encerrada',
    class: 'bg-base-mantis-500',
  },
  [AssessmentStatusAttemptEnum.Review]: {
    text: 'gestor-avaliacoes.status.revisar',
    class: 'bg-red-500',
  },
  [AssessmentStatusAttemptEnum.ModelUndefined]: {
    text: 'gestor-avaliacoes.status.modelo-nao-identificado',
    class: 'bg-red-500',
  },
  [AssessmentStatusAttemptEnum.ResponseCardInvalid]: {
    text: 'gestor-avaliacoes.status.cartao-invalido',
    class: 'bg-red-500',
  },
  [AssessmentStatusAttemptEnum.ResponseCardDivergent]: {
    text: 'gestor-avaliacoes.status.cartao-divergente',
    class: 'bg-red-500',
  },
  [AssessmentStatusAttemptEnum.Unassigned]: {
    text: 'gestor-avaliacoes.status.nao-atribuido',
    class: 'bg-red-500',
  },
};

export function getAttemptStatus(student: AttemptStudentData) {
  const status =
    !!student &&
    !student.usuario_id &&
    ![AssessmentStatusAttemptEnum.ResponseCardDivergent, AssessmentStatusAttemptEnum.ResponseCardInvalid].includes(
      student.status,
    )
      ? AssessmentStatusAttemptEnum.Unassigned
      : student?.status ?? 999;

  return STATUS_LABEL[status];
}
